export default function isInViewport(group, container, selector) {
    let $this = $(group);
    if($this.length < 1) return false;
    let $topBar = $(container).outerHeight();
    let $elementTop = $this.offset().top;
    let $elementBottom = $elementTop + $this.outerHeight();
    let $viewportTop = $(window).scrollTop() + $topBar;
    let $viewportBottom = $viewportTop + $(selector).height() / 2;

    return $elementBottom > $viewportTop && $elementTop < $viewportBottom;
}

export function isPartialElementInViewPort(group, selector) {
    let $this = $(group);
    if($this.length < 1) return false;
    let $elementTop = $this.offset().top;
    let $elementBottom = $elementTop + $this.outerHeight();
    let $viewportTop = $(window).scrollTop();
    let $viewportBottom = $viewportTop + $(selector).height();

    return $elementBottom > $viewportTop && $elementTop < $viewportBottom;
}
